import React, { useEffect, useState } from "react";
import PageHeading from "../../../../components/common/PageHeading";
import {
  Form,
  Input,
  Select,
  Col,
  Row,
  Card,
  Checkbox,
  Radio,
  Space,
  DatePicker,
  Button,
  message,
} from "antd";
import { workOrderType, priority } from "../../../../utils/Util";
import TextArea from "antd/es/input/TextArea";
import FormAction from "../../../../components/common/FormAction";
import { useForm } from "antd/lib/form/Form";
import moment from "moment";

import {
  getDocs,
  collection,
  doc,
  query,
  where,
  getDoc,
} from "firebase/firestore";
import { auth, db } from "../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { createNewServiceRequest } from "./NewServiceRequestFirebase";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { SelectProfileInfo } from "../../../../store/moveInTenantSlice";
import { SelectUser } from "../../../../store/usersSlice";
import toast from "react-hot-toast";

export const vendorTrade = [
  { value: "No Trade Assigned" },
  { value: "Alarm/Security" },
  { value: "Appliances" },
  { value: "Capital Improvements" },
  { value: "Carpet Cleaning" },
  { value: "Carpet/Flooring" },
  { value: "Cleaning" },
  { value: "Deck Repair" },
  { value: "Doors/Windows" },
  { value: "Drywall Repair" },
  { value: "Electrical" },
  { value: "Elevator Services" },

  { value: "Fences/Gates" },
  { value: "Fire/Water Demage" },
  { value: "Fireplace/Chimny" },
  { value: "Garage Doors" },
  { value: "General Contractor" },
  { value: "Gutter Cleaning" },
  { value: "HVAC" },
  { value: "Handyperson" },
  { value: "Inspections" },
  { value: "Keys/Locks" },
  { value: "Landscraping" },
  { value: "Others" },
  { value: "Painting" },

  { value: "Parking Lots/Driveways" },
  { value: "Pest Control" },
  { value: "Plumbing" },
  { value: "Pool/Spa" },
  { value: "Preventative Maintenance" },
  { value: "Redevelopment" },
  { value: "Repairs and Maintenance: Exterior" },
  { value: "Repairs and Maintenance: Interior" },
  { value: "Roofing" },
  { value: "Septic System" },
  { value: "Smoke/Carbon Monoxide Detectors" },
  { value: "Snow Removal" },
  { value: "Trash/Recycling" },
  { value: "Turnover" },
  { value: "Utilities" },
];

function NewServiceRequest() {
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);

  const [properties, setProperties] = useState([]);
  const [allProperties, setAllProperties] = useState({});
  const [unitTurnData, setUnitTurnData] = useState();
  const [vendors, setVendors] = useState([]);
  const [vendorEmail, setVendorEmail] = useState(true);
  const [vendorContact, setVendorContact] = useState(false);
  const [isShowForm, setIsShowForm] = useState(false);
  const [isWait, setIsWait] = useState(false);
  const navigate = useNavigate();

  const userData = useSelector(SelectUser);
  const createdBy = userData.uid;
  console.log("User id", createdBy);

  // ?unit_turn_id=IkrweH0SSCrAxi4z4WMG&unit_turn_category=Appliances
  const [unitTurnId, setunitTurnId] = useState("");
  const [unitTurnCategory, setUnitTurnCategory] = useState("");
  const [propertyId, setPropertyId] = useState("");
  useEffect(() => {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    const id = searchParams.get("unit_turn_id");
    const category = searchParams.get("unit_turn_category");
    const p_id = searchParams.get("propertyId");
    setunitTurnId(id);
    setUnitTurnCategory(category);
    setPropertyId(p_id);
    if (id?.length > 0) {
      setIsShowForm(false);
    } else {
      setIsShowForm(true);
    }
  }, []);

  console.log("unitTurnId:", unitTurnId?.length);
  console.log("unitTurnCategory:", unitTurnCategory);
  console.log("allProperties:", allProperties);
  const [form] = useForm();

  const onFinish = (values) => {
    setIsWait(true);
    const formattedDate = moment(values.date).format("YYYY-MM-DD");
    console.log("uid3333", createdBy);

    const updatedValues = {
      ...values,
      date: formattedDate,
    };
    try {
      if (unitTurnId?.length > 0) {
        createNewServiceRequest(
          updatedValues,
          companyName,
          propertyId,
          createdBy,
          unitTurnId,
          unitTurnCategory,
          true
        ).then(() => {
          toast.success("New unit Service Request Created SuccessFully!", 2);
          navigate("/maintenance/work-orders");
          setIsWait(false);
        });
      } else {
        createNewServiceRequest(
          updatedValues,
          companyName,
          propertyId,
          createdBy,
          false
        ).then(() => {
          toast.success("New Service Request Created SuccessFully!", 2);
          navigate("/maintenance/work-orders");
          setIsWait(false);
        });
      }
    } catch (err) {
      console.log(err);
      setIsWait(false);
    }

    console.log("Form values:", updatedValues);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("failed");
    console.log(errorInfo);
    setIsWait(false);
  };

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            //  console.log(res, "companyName")
            setcompanyName(res.companyName);
          });
          setIsCompanyNameFetched(true);
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    if (unitTurnId?.length > 0) {
      const getUnitTurnDocument = async () => {
        const companiesRef = collection(db, "companies");
        const companyDocRef = doc(companiesRef, companyName);
        const unitTurnRef = collection(companyDocRef, "unitTurns");

        const unitTurnDocRef = doc(unitTurnRef, unitTurnId);
        const unitTurnDocSnapshot = await getDoc(unitTurnDocRef);

        if (unitTurnDocSnapshot.exists()) {
          const unitTurnDocData = unitTurnDocSnapshot.data();
          console.log("unitTurnDocData", unitTurnDocData);
          setUnitTurnData(unitTurnDocData);
        } else {
          console.log("Unit turn document does not exist");
        }
      };
      getUnitTurnDocument();
    }

    console.log("^^^^^^^^^^^^^^^");
  }, [companyName, isCompanyNameFetched, unitTurnId]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;

    const fetchProperties = async () => {
      try {
        const companiesRef = collection(db, "companies");
        const companyDocRef = doc(companiesRef, companyName);
        const propertiesRef = collection(companyDocRef, "properties");
        const querySnapshot = await getDocs(propertiesRef);

        console.log("...", querySnapshot);

        const fetchedData = querySnapshot?.docs?.map((doc) => ({
          value: doc.id,
          label: doc?.data()?.propertyNameAddress?.propertyName,
        }));

        const fetchedProperties = querySnapshot?.docs?.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const filteredData = fetchedProperties?.filter(
          (item) => item.id === unitTurnData?.unitId
        );
        setAllProperties(filteredData[0]);
        setProperties(fetchedData);
        console.log(fetchedProperties, "fetchedProperties..");
        console.log(filteredData, "filteredData..");
        console.log(unitTurnData?.unitId, "unitTurnData.unitId..");
        setTimeout(() => {
          setIsShowForm(true);
        }, 1000);
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    fetchProperties();
    console.log("usingg useEffect 1");
  }, [companyName, isCompanyNameFetched, unitTurnData]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;

    const fetchVendors = async () => {
      try {
        const companiesRef = collection(db, "companies");
        const companyDocRef = doc(companiesRef, companyName);
        const vendorsRef = collection(companyDocRef, "vendors");
        const querySnapshot = await getDocs(vendorsRef);

        console.log("...", querySnapshot);

        const fetchedVendors = querySnapshot?.docs?.map((doc) => ({
          id: doc.id,
          value: doc.id,
          label: `${doc?.data()?.vendorInfo?.firstName} ${
            doc?.data()?.vendorInfo?.lastName
          }`,
          vendorContact: doc?.data()?.contact?.phoneNumbers[0]?.phoneNumber,
          vendorEmail: doc?.data()?.contact?.emails[0]?.email,
        }));

        setVendors(fetchedVendors);
        console.log(fetchedVendors, "fetching vendor");
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    //console.log("propArraypropArray", propArray)

    fetchVendors();
    console.log("usingg useEffect 1");
  }, [companyName, isCompanyNameFetched]);

  const propertyArr = [];
  properties?.forEach((element) => {
    propertyArr.push(element.value);
    console.log(element, "element");
  });
  const vendorArr = [];
  vendors?.forEach((element) => {
    vendorArr.push(element.value);
    console.log(element, "element");
  });
  const handleChange = (selectedValue) => {
    setSelectedVendor(selectedValue);
    // console.log('Selected value:', selectedValue);

    const foundItem = vendors.find((item) => item.value === selectedValue);

    if (foundItem.vendorEmail) {
      setVendorEmail(false);
    }
    if (foundItem.vendorContact) {
      setVendorContact(false);
    }
  };
  const handleCancel = () => {
    navigate("/maintenance/work-orders");
  };

  const unitTurnCategoryList = [
    {
      value: "Maintenance / Repair",
    },
    {
      value: "Paint",
    },
    {
      value: "Appliances",
    },
    {
      value: "Floors / Carpets",
    },
    {
      value: "Other",
    },
    {
      value: "Housekeeping",
    },
    {
      value: "Keys / Locks",
    },
    {
      value: "Gutters",
    },
    {
      value: "Exterior Paint",
    },
    {
      value: "Pest Control",
    },
    {
      value: "Windows",
    },
  ];
  const defaultValues = {
    property: allProperties
      ? allProperties?.propertyNameAddress?.propertyName
      : "",
    unit: allProperties ? allProperties?.propertyNameAddress?.propertyName : "",
    workOrderType: "Unit Turns",
    unit_turn_category: unitTurnCategory,
    permission: "Yes",
  };
  return (
    <div>
      <PageHeading heading="New Service Request" />
      {isShowForm && (
        <Form
          name="basic"
          labelCol={{ span: 7 }}
          initialValues={defaultValues} // Pass the defaultValues object here
          autoComplete="off"
          className="form-container"
          colon={false}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
        >
          <Row>
            <Col span={24}>
              {/* Owner Information */}

              <Card
                title="Property, Association, Homeowner, or Tenant"
                bordered={false}
              >
                <Form.Item
                  name="property"
                  label="Property"
                  rules={[
                    {
                      required: true,
                      message: "Please Select Property!",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    options={properties}
                    disabled={unitTurnId?.length > 0 ? true : false}
                  />
                </Form.Item>

                <Form.Item name="unit" label="Unit">
                  <Input disabled />
                </Form.Item>

                <Form.Item name="workOrderType" label="Work Order Type">
                  <Select
                    options={workOrderType}
                    disabled={unitTurnId?.length > 0 ? true : false}
                  />
                </Form.Item>

                <Form.Item label="Permission To Enter" name="permission">
                  <Radio.Group>
                    <Space direction="vertical" style={{ marginTop: 6 }}>
                      <Radio value={"Yes"}>Yes</Radio>
                      <Radio value={"No"}>No</Radio>
                      <Radio value={"not Applicable"}>Not Applicable</Radio>
                    </Space>
                  </Radio.Group>
                </Form.Item>

                <Form.Item
                  label="Additional Information Regarding Entry"
                  name="additionalInfo"
                >
                  <TextArea rows={2} />
                </Form.Item>

                <Form.Item label="Priority" name="priority">
                  <Select options={priority} />
                </Form.Item>

                <Form.Item
                  label="Description"
                  name="description"
                  rules={[
                    {
                      required: true,
                      message: "Description can't be blank!",
                    },
                  ]}
                >
                  <TextArea rows={4} />
                </Form.Item>

                <Form.Item label=" ">
                  <p style={{ fontSize: 12 }}>
                    The Service Request description will detail the reported
                    issue, and is for internal use only.
                  </p>
                </Form.Item>

                <Form.Item
                  label="Use service request description as work order job description"
                  name="useServiceRequest"
                  valuePropName="checked"
                >
                  <Checkbox />
                </Form.Item>
              </Card>

              <br />

              <Card title="Work Order Information" bordered={false}>
                <Form.Item
                  label="Owner approved"
                  name="ownerApproved"
                  valuePropName="checked"
                >
                  <Checkbox />
                </Form.Item>

                <Form.Item label="Job Description" name="jobDescription">
                  <TextArea rows={4} />
                </Form.Item>

                <Form.Item label=" ">
                  <p style={{ fontSize: 12 }}>
                    The Work Order Job Description is specific to a single work
                    order and will be visible on the printed work order.
                  </p>
                </Form.Item>

                <Form.Item label="Vendor Instructions" name="vendorInstruction">
                  <TextArea rows={4} />
                </Form.Item>

                {unitTurnId?.length > 0 && (
                  <Form.Item
                    label="Unit Turn Category"
                    name="unit_turn_category"
                  >
                    <Select options={unitTurnCategoryList} />
                  </Form.Item>
                )}
                <Form.Item label="Vendor Trade" name="vendorTrade">
                  <Select options={vendorTrade} />
                </Form.Item>

                <Form.Item label="Vendor Suggestions">
                  <p style={{ fontSize: 12 }}>
                    Assign a vendor trade to generate suggestions.
                  </p>
                </Form.Item>

                <Form.Item
                  label="Vendor"
                  name="vendor"
                  rules={[
                    {
                      required: true,
                      message: "Please select a vendor",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    options={vendors}
                    onChange={handleChange}
                  />
                </Form.Item>

                {selectedVendor !== null ? (
                  <>
                    <Form.Item
                      label="Email vendor a secure link to view this work order"
                      name="emailVendor"
                      valuePropName="checked"
                      disabled={vendorEmail}
                    >
                      <Checkbox />
                    </Form.Item>

                    <Form.Item
                      label="Text vendor a secure link to view this work order"
                      name="textVendor"
                      valuePropName="checked"
                      disabled={vendorContact}
                    >
                      <Checkbox />
                    </Form.Item>

                    <Form.Item
                      label="Request vendor to confirm receipt of work order"
                      name="requestVendor"
                      valuePropName="checked"
                    >
                      <Checkbox />
                    </Form.Item>
                  </>
                ) : (
                  <></>
                )}
                <Form.Item label="Assign To" name="assignTo">
                  <Input placeholder="Start typing to search" disabled />
                </Form.Item>
                <Form.Item label="Follow-up Date" name="followUpDate">
                  <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
                </Form.Item>
              </Card>

              <br />

              <FormAction submit="submit" cancel={handleCancel} loading={isWait}/>

              <div className="RightSidebar" />
            </Col>
          </Row>
        </Form>
      )}
    </div>
  );
}

export default NewServiceRequest;
